import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	listItemDescription: {
		flex: 1,
		fontSize: "18px",
		fontWeight: 800
	},
	enabledInstance: {
		cursor: "pointer"
	},
	hoveredInstance: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	disabledInstance: {
		cursor: "not-allowed"
	}
}))

export default useStyles
